import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=9e1ff740&scoped=true"
var script = {}
import style0 from "./Legal.vue?vue&type=style&index=0&id=9e1ff740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@7.0.0-bridge.0_@babel+core@7.26.7__cac_fzj6xqfhz2iur5pptcdfbzd24y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1ff740",
  null
  
)

export default component.exports